package top.wcpe.allincore.layout.engine

/**
 * 交叉轴对齐方式（不含 SPACE_*）。
 */
enum class Align {
    START,
    CENTER,
    END,
    STRETCH
}
